import './Loader.css';

type LoaderProps = { size?: 'icon' | 'line' | 'box' | 'grid' };
export const Loader = ({ size = 'box' }: LoaderProps): JSX.Element => {
	if (size === 'grid') {
		return (
			<div className="product-listing">
				<Loader size="box" />
				<Loader size="box" />
				<Loader size="box" />
				<Loader size="box" />
				<Loader size="box" />
			</div>
		);
	}
	return <loader-placeholder class={size}></loader-placeholder>;
};
